export default __webpack_public_path__ + "static/media/faqs.544f1743.svg";